import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type ChassisSearchMoto = {
  id: string;
  modele: string;
  vin: string;
  kilometrage: number | null;
  annee: number | null;
  client: {
    id: string;
    nom: string;
    prenom: string;
    telephone: string;
    email?: string | null;
  };
};

/**
 * Recherche de motos par numéro de châssis (VIN) avec debounce 200ms.
 * Endpoint backend : GET /motos/search-by-vin?q=
 */
export function useChassisSearch(query: string, enabled = true) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebouncedQuery(query), 200);
    return () => window.clearTimeout(handle);
  }, [query]);

  return useQuery({
    queryKey: ['motos', 'search-by-vin', debouncedQuery],
    queryFn: () =>
      api.get<{ motos: ChassisSearchMoto[] }>(
        `/motos/search-by-vin?q=${encodeURIComponent(debouncedQuery)}`,
      ),
    select: (d) => d.motos,
    enabled: enabled && debouncedQuery.trim().length >= 2,
    staleTime: 30_000,
  });
}
